import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DashboardData from './DashboardData';
import TopCards from './TopCards';



function DashboardPage() {
    useEffect(() => {
    }, [])
    return (
        <Container fluid>
            <TopCards />
            <DashboardData/>
        </Container>
    )
}
export default DashboardPage;